<template>
  <div class="row justify-content-center">
    <div class="col-lg-5 col-md-7">
      <div v-if="!showVerificationForm" class="card bg-neutral shadow border-0">
        <div class="card-body px-lg-5 py-lg-5">
          <div class="text-center text-muted mb-4">
            <b><small>Sign in with</small></b>
          </div>
          <div v-if="alertText">
            <base-alert type="danger">{{ alertText }}</base-alert>
          </div>
          <div class="btn-wrapper text-center">
            <a
              :href="SSOUri"
              class="btn-block btn-primary btn-lg"
              type="button"
            >
              PMI AZURE SSO
            </a>
          </div>
          <br />
          <div class="dropdown-divider"></div>

          <div class="text-center text-muted mb-4">
            <small>Or sign in with credentials</small>
          </div>
          <form role="form">
            <base-input
              class="input-group-alternative mb-3"
              placeholder="Email"
              addon-left-icon="ni ni-email-83"
              v-model="model.email"
            >
            </base-input>

            <base-input
              class="input-group-alternative"
              placeholder="Password"
              type="password"
              addon-left-icon="ni ni-lock-circle-open"
              v-model="model.password"
            >
            </base-input>
            <div class="text-center">
              <base-button type="primary" class="my-4" v-on:click="signIn"
                >Sign in</base-button
              >
            </div>
          </form>
        </div>
      </div>

      <!-- verification form -->
      <div
        v-if="showVerificationForm"
        class="card bg-secondary shadow border-0"
      >
        <div class="card-body px-lg-5 py-lg-5">
          <div class="text-center text-muted mb-4 text-red">
            <small
              >Your account is not yet verified. Please verify it below to
              continue.</small
            >
          </div>
          <div v-if="changePasswordMessage">
            <base-alert :type="changePasswordMessage.type">{{
              changePasswordMessage.message
            }}</base-alert>
          </div>
          <form role="form">
            <base-input
              class="input-group-alternative mb-3"
              placeholder="Current Password"
              type="password"
              addon-left-icon="ni ni-email-83"
              v-model="changePassword.currentPassword"
            >
            </base-input>
            <base-input
              class="input-group-alternative"
              placeholder="New Password"
              type="password"
              addon-left-icon="ni ni-lock-circle-open"
              v-model="changePassword.newPassword"
            >
            </base-input>
            <base-input
              class="input-group-alternative"
              placeholder="Confirm New Password"
              type="password"
              addon-left-icon="ni ni-lock-circle-open"
              v-model="changePassword.newPasswordConfirmation"
            >
            </base-input>
            <div class="text-center">
              <base-button
                type="primary"
                class="my-4"
                v-on:click="updatePassword"
                >Submit</base-button
              >
            </div>
          </form>
        </div>
      </div>
      <!-- end of verification form -->

      <!-- taking out forgot password functionality -->
      <!-- <div class="row mt-3">
        <div class="col-sm"></div>
        <div class="col-sm">
          <router-link to="forgot-password"
            ><small>Forgot password?</small></router-link
          >
        </div>
        <div class="col-sm"></div>
      </div> -->
      <!-- taking out forgot password functionality -->
    </div>
  </div>
</template>

<script>
import { Auth } from "aws-amplify";
import router from "./../router";
import api_loyalty from "./../api/api";
import NProgress from "nprogress";

export default {
  name: "login",
  data() {
    return {
      SSOUri: "",
      alertText: null,
      showVerificationForm: false,
      model: {
        email: "",
        password: "",
      },
      changePasswordMessage: null,
      changePasswordUser: null,
      changePassword: {
        currentPassword: "",
        newPassword: "",
        newPasswordConfirmation: "",
      },
    };
  },
  created() {
    let env = api_loyalty.AllConfig().api_url.Tools_Env;
    let cognitoCustomURL = api_loyalty.AllConfig().api_url.CognitoCustomDomain
    let redirect_uri = api_loyalty.AllConfig().api_url.SSO_CallbackUrl;
    let client_id = api_loyalty.AllConfig().cognito.aws_user_pools_web_client_id;
    let providername = `wfiws-${env}-ems-auth-azuresso`;
    this.SSOUri = `${cognitoCustomURL}/oauth2/authorize?identity_provider=${providername}&redirect_uri=${redirect_uri}&response_type=code&client_id=${client_id}&scope=aws.cognito.signin.user.admin%20email%20openid`;
    let codeSSO = this.$route.query.code;
    if (codeSSO) {
      console.log(codeSSO);
      api_loyalty.cognitoOauth2(codeSSO).then((data) => {
        sessionStorage.setItem(
          "CognitoIdentityServiceProvider." +
            client_id +
            "." +
            data.user_info.sub +
            ".refreshToken",
          data.token_info.refresh_token
        );
        sessionStorage.setItem(
          "CognitoIdentityServiceProvider." +
            client_id +
            "." +
            data.user_info.sub +
            ".clockDrift",
          1
        );
        sessionStorage.setItem(
          "CognitoIdentityServiceProvider." +
            client_id +
            "." +
            data.user_info.sub +
            ".accessToken",
          data.token_info.access_token
        );
        sessionStorage.setItem(
          "CognitoIdentityServiceProvider." + client_id + ".LastAuthUser",
          data.user_info.sub
        );
        sessionStorage.setItem(
          "CognitoIdentityServiceProvider." +
            client_id +
            "." +
            data.user_info.sub +
            ".idToken",
          data.token_info.id_token
        );
        this.$store.dispatch("fetchLoginUser");
        this.$store.dispatch("getRoleMapping");
        router.push({ name: "dashboard" });
      });
    }
  },
  methods: {
    async signIn() {
      if (this.model.email.trim() == "" || this.model.password.trim() == "") {
        this.alertText = "Username and password required.";
      } else {
        try {
          NProgress.start();
          const { email, password } = this.model;
          let signin = await Auth.signIn(email.trim(), password.trim());
          if (signin.challengeName === "NEW_PASSWORD_REQUIRED") {
            this.changePasswordUser = signin;
            this.showVerificationForm = true;
          } else {
            await this.$store.dispatch("fetchLoginUser");
            await this.$store.dispatch("getRoleMapping");
            if (
              this.$store.getters.loginUser.groups.length == 1
            ) {
              this.alertText = "Invalid user permission.";
              Auth.signOut()
                .then(() => {
                  localStorage.clear();
                  console.log("kickout, invalid permission");
                })
                .catch((e) => {
                  console.log(e);
                });
            } else {
              router.push({ name: "dashboard" });
            }
          }
          NProgress.done();
        } catch (e) {
          console.log(e);
          NProgress.done();
          this.alertText = "Invalid username or password.";
        }
      }
    },
    async updatePassword() {
      this.changePasswordMessage = null;

      if (!this.validateChangePasswordForm()) {
        this.changePasswordMessage = {
          message: "Validation failed.",
          type: "danger",
        };
      } else {
        NProgress.start();
        api_loyalty
          .completeNewPassword(
            this.changePasswordUser,
            this.changePassword.newPassword
          )
          .then(() => {
            NProgress.done();
            this.changePasswordMessage = {
              message: "Password updated successfully. Redirecting...",
              type: "success",
            };
            this.changePassword = {
              currentPassword: "",
              newPassword: "",
              newPasswordConfirmation: "",
            };
            this.$store.dispatch("fetchLoginUser").then(() => {
              router.push({ name: "dashboard" });
            });
            this.$store.dispatch("getRoleMapping");
          })
          .catch((e) => {
            NProgress.done();
            console.log(e);
            this.changePasswordMessage = {
              message: "Failed to update password.",
              type: "danger",
            };
          });
      }
    },
    validateChangePasswordForm() {
      return (
        this.changePassword.currentPassword.trim().length > 0 &&
        this.changePassword.newPassword.trim().length > 8 &&
        this.changePassword.newPassword.trim() ===
          this.changePassword.newPasswordConfirmation.trim()
      );
    },
  },
};
</script>
<style></style>
